import type { schemaType } from '~~/shared/api/rurality/v3/search/cottages/schema'
import type { schemaType as mapSchemaType } from '~~/shared/api/rurality/v3/search/cottages/map/schema'
import { browserFetch as useNewMultiStats } from '~~/modules/api/rurality/v3/stats/cottage/new-multi'
import { browserFetch as useNewRawStats } from '~~/modules/api/rurality/v3/stats/cottage/new-raw'
import { browserFetch as useNewStats } from '~~/modules/api/rurality/v3/stats/cottage/new'

export function useSendCottageStats() {
  const sendCottageStats = async (
    cottagesData: schemaType | undefined,
  ): Promise<void> => {
    if (!cottagesData) {
      return
    }

    const allCottages = [
      ...(cottagesData.cottages ?? []),
      ...(cottagesData.nearCottages ?? []),
    ]

    const allIds = allCottages.map(cottage => cottage.id)
    const freeCancellationIds = allCottages
      .filter(cottage => cottage.hasFreeCancellations)
      .map(cottage => cottage.id)

    const calls = [
      useNewMultiStats({
        cottageIds: allIds,
        eventType: 'search_card_viz',
      }),
    ]
    if (freeCancellationIds.length) {
      calls.push(
        useNewMultiStats({
          cottageIds: freeCancellationIds,
          eventType: 'search_free_cancellation',
        }),
      )
    }
    try {
      await Promise.all(calls)
    } catch (error) {
      console.error('sendCottageStats error ', cottagesData)
    }
  }

  const sendCottageStatsCloudwatch = async (
    cottagesData: schemaType | undefined,
  ): Promise<void> => {
    if (!cottagesData) {
      return
    }

    const route = useRoute()
    const path = route.path

    const queryParams = new URLSearchParams(
      route.query as Record<string, string>,
    ).toString()
    const parameters = queryParams || null
    const totalResults = cottagesData.totalCottages ?? null

    try {
      await useNewRawStats({
        path,
        parameters,
        totalResults,
      })
    } catch (error) {
      console.error('sendCottageStatsCloudwatch error ', cottagesData)
    }
  }

  const sendMapCottageStatsCloudwatch = async (
    cottagesData: mapSchemaType | undefined,
  ): Promise<void> => {
    if (!cottagesData) {
      return
    }

    const route = useRoute()
    const path = route.path

    const queryParams = new URLSearchParams(
      route.query as Record<string, string>,
    ).toString()
    const parameters = queryParams || null
    const totalResults = cottagesData.totalResults ?? null

    try {
      await useNewRawStats({
        path,
        parameters,
        totalResults,
      })
    } catch (error) {
      console.error('sendMapCottageStatsCloudwatch error ', cottagesData)
    }
  }

  const sendMapCottageCardViz = async (cottageId: string): Promise<void> => {
    try {
      await useNewStats({ cottageId, eventType: 'search_card_viz' })
    } catch (error) {
      console.error('sendMapCottageCardViz error ', cottageId)
    }
  }

  return {
    sendCottageStats,
    sendCottageStatsCloudwatch,
    sendMapCottageStatsCloudwatch,
    sendMapCottageCardViz,
  }
}
